<template>
  <div>
    <Header></Header>
    <div id="main">
      <div class="container">
        <div class="row">
          <div id="create-project-intro">
            <h1 v-if="isEvent">Como você quer transformar?</h1>
            <h1 v-else>O que você quer transformar?</h1>
            <form>
              <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
                {{msg}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMessage()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="form-group">
                <label v-if="isEvent">Nome do seu Convite do Bem:</label>
                <label v-else>Nome de sua Organização Social ou título de sua campanha:</label>
                <span class="pull-right">Máximo de 40 caractéres</span>
                <input v-model="title" type="text" name="title" class="form-control" placeholder="Exemplo: Aniversário do André"/>
                <span>Taxa de conveniência de 8,90%, referente à taxa cobrada pelo meio de pagamento, sistema antifraude e manutenção desta ferramenta.</span>
              </div>
              <div class="submit">
                <button @click.stop.prevent="create()" class="btn">Continuar</button>
                <span>Não se preocupe, você poderá alterar o nome depois.</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import auth from '../services/auth'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'CreateProject',
  components: {
    Header,
    Footer,
    Loading
  },
  data () {
    return {
      msg: '',
      showMsg: false,
      loading: true,
      title: null,
      user: null,
      isEvent: false,
    }
  },
  mounted () {
    this.isEvent = (this.$route.params.type == 'event') ? true : false;
    this.getProfile()
  },
  methods: {
    getProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((result) => {
        this.user = result.body.user;
        this.loading = false;
      }, (err) => {
        auth.logout();
        this.$router.push('/login');
      });
    },
    create(){
      this.loading = true;
      if(this.validate()){
        this.$http.post(API.Projects.createProject, {title: this.title, type: (this.isEvent) ? 'event' : 'project'},
        {headers: auth.getHeaders()}).then((res) => {
          if(res.body.success === true){
            this.$router.push('/project/manage/' + res.body.slug);
          }else{
            this.showMessage("Ocorreu um erro no cadastro do projeto!");
          }
          this.loading = false;
        });
      }else{
        this.loading = false;
      }
    },
    validate(){
      if(this.title == null || this.title == ''){
        this.showMessage("Insira um título para o seu projeto!");
        return false;
      }
      return true;
    },
    showMessage(msg){
      this.msg = msg;
      this.showMsg = true;
    },
    hideMessage(){
      this.msg = "";
      this.showMsg = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  padding-bottom: 100px;
}
#create-project-intro{
  background-color: #eee;
  width: 100%;
  padding-top: 20px;
  height: 500px;
  border-radius: 10px;
  h1{
    text-align: center;
    padding: 10px;
    font-family: RalewayBold;
    margin-top: 20px;
  }

  form{
    padding: 30px;
    margin-top: 50px;

    .form-group{
      span{
        float: left;
        font-size: 14px;
        margin-top: 5px;
        color: #999;
        &.pull-right{
          float: right;
        }
      }
      input{
        font-size: 22px;
      }
    }
    .submit{
      width: 100%;
      margin-top: 70px;
      text-align: center;
      span{
        display: block;
        margin-top: 20px;
      }
      button{
        background-color: #00AE39;
        font-size: 26px;
        padding-left: 20px;
        padding-right: 20px;
        color: #fff;
        &:hover{
          background-color: #aaa;
          color: #333;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CreateProject.vue